const normalizeDocTypeKey = (value = '') =>
  String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '');

const quotationGrossAmount = (netTotal) => {
  const net = Number(netTotal || 0);
  if (!Number.isFinite(net) || net === 0) return 0;
  return Math.round(net * 1.19 * 100) / 100;
};

const amountsClose = (left, right, tolerance = 1) =>
  Math.abs(Number(left || 0) - Number(right || 0)) <= tolerance;

/** Monto firmado de un documento: facturas/boletas/ND suman, NC restan. */
export const getDocumentBillingDelta = (document) => {
  const key = normalizeDocTypeKey(document?.document_type);
  const net = Number(document?.net_amount ?? 0);
  const total = Number(document?.total_amount ?? 0);
  const magnitude = Math.abs(net) > 1e-9
    ? Math.abs(net)
    : Math.abs(total);

  if (!magnitude) return 0;

  const isCredit = key.includes('credito') || total < 0 || net < 0;
  return isCredit ? -magnitude : magnitude;
};

export const sumLinkedBillingDocuments = (documents = []) =>
  (documents || []).reduce((acc, document) => acc + getDocumentBillingDelta(document), 0);

export const isBillingSectionComplete = (documents, quotationNetAmount) => {
  if (!documents?.length) return false;

  const linkedTotal = sumLinkedBillingDocuments(documents);
  const targetNet = Number(quotationNetAmount || 0);
  const targetGross = quotationGrossAmount(targetNet);

  return amountsClose(linkedTotal, targetNet) || amountsClose(linkedTotal, targetGross);
};

export const getBillingSectionStatus = (documents, quotationNetAmount) => {
  if (!documents?.length) return 'empty';
  return isBillingSectionComplete(documents, quotationNetAmount) ? 'invoiced' : 'invoiced_partial';
};
